import React from "react";
import { AssetManagement } from "@components/Asset";
import { useTranslation } from "react-i18next";
export default function AssetLibrary({
  isIndex,
  locationId,
  organizationId,
  library,
}) {
  const { t } = useTranslation();
  return (
    <AssetManagement
      title={t("mixer:asset_library")}
      library={library}
      isIndex={isIndex}
      locationId={locationId}
      organizationId={organizationId}
    />
  );
}
